import { render, staticRenderFns } from "./businessdetails.vue?vue&type=template&id=51b777b4"
import script from "./businessdetails.vue?vue&type=script&lang=js"
export * from "./businessdetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports